import { apiGet, apiPatch } from './client';
import type { CalcMethod, CalcMethodBatchRequest } from '../types/CalcMethod';

export function getCalcMethods(): Promise<CalcMethod[]> {
  return apiGet<CalcMethod[]>('/api/calc-methods');
}

export function saveCalcMethodsBatch(
  added: CalcMethod[],
  modified: CalcMethod[],
  deletedIds: number[],
): Promise<CalcMethod[]> {
  return apiPatch<CalcMethodBatchRequest, CalcMethod[]>('/api/calc-methods/batch', {
    added,
    modified,
    deleted: deletedIds,
  });
}
